import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { COLLABORATOR_ROLE_KEYS } from '@restworld/feature-authentication';

function useCollaboratorPermissionLevelList() {
  const { t } = useTranslation('collaborators-page');

  const permissionLevels = useMemo(
    () => [
      { id: COLLABORATOR_ROLE_KEYS.ADMIN, key: COLLABORATOR_ROLE_KEYS.ADMIN, label: t('admin_level') },
      { id: COLLABORATOR_ROLE_KEYS.BASE, key: COLLABORATOR_ROLE_KEYS.BASE, label: t('base_level') },
    ],
    [t]
  );

  return permissionLevels;
}
export default useCollaboratorPermissionLevelList;
